// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/cropperjs/dist/cropper.css
// module id = 1179
// module chunks = 2